<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item label="Parent Name:" prop="parentName">
            <el-input style="width: 300px" v-model="form.parentName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label=" Consolidated financials within days:"
            prop="consolidatedFinancialsWithinDays"
          >
            <el-input
              onkeyup="value=value.replace(/[^\d]/g,'')"
              style="width: 300px"
              v-model="form.consolidatedFinancialsWithinDays"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col>
          <el-form-item label="Fiscal Period:" prop="fiscalPeriod">
            <el-select v-model="form.fiscalPeriod">
              <el-option
                :key="item.value"
                v-for="item in fiscalArr"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    const fiscalArr = [
      { value: 1, label: 'annually' },
      { value: 2, label: 'half year' },
      { value: 3, label: 'quarterly' },
    ]
    return {
      formName: 'CMA',
      fiscalArr,
      form: {
        parentName: '',
        fiscalPeriod: '',
        consolidatedFinancialsWithinDays: '',
      },
      commonFormData: {},
      rules: {
        parentName: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        fiscalPeriod: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        consolidatedFinancialsWithinDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(this.form, 'parentName', newValue.parentName)
        this.$set(this.form, 'fiscalPeriod', newValue.fiscalPeriod)
        this.$set(
          this.form,
          'consolidatedFinancialsWithinDays',
          newValue.consolidatedFinancialsWithinDays,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
